(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5692],{

/***/ 68387:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embedded-checkout/cart",
      function () {
        return __webpack_require__(62335);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LS": function() { return /* binding */ setItem; },
/* harmony export */   "MU": function() { return /* binding */ setListener; },
/* harmony export */   "cl": function() { return /* binding */ removeItem; },
/* harmony export */   "rV": function() { return /* binding */ getItem; }
/* harmony export */ });
var safeGetLocalStorage = function() {
    try {
        return window === null || window === void 0 ? void 0 : window.localStorage;
    } catch (_err) {
        // Catch a SecurityError that is thrown if the browser has disabled access
        // to local storage
        return undefined;
    }
};
var setListener = function(cb) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    window.addEventListener("storage", function(e) {
        cb(e);
    });
};
// biome-ignore lint/suspicious/noExplicitAny: Allow saving anything in local storage
var setItem = function(key, value) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    var stringToStore = JSON.stringify(value);
    storage.setItem(key, stringToStore);
};
var getItem = function(key) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return undefined;
    }
    var string = storage.getItem(key);
    return string ? JSON.parse(string) : string;
};
var removeItem = function(key) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(key);
};


/***/ }),

/***/ 37175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rV": function() { return /* binding */ getItem; },
  "cl": function() { return /* binding */ removeItem; },
  "LS": function() { return /* binding */ setItem; }
});

// UNUSED EXPORTS: isAvailable

// EXTERNAL MODULE: ../../../../browser-sdk/src/libraries/local-storage.ts
var local_storage = __webpack_require__(93960);
;// CONCATENATED MODULE: ../../../../browser-sdk/src/libraries/broadcast-message.js

function broadcastMessageToTabs(key, value) {
    (0,local_storage/* setItem */.LS)(key, value);
    (0,local_storage/* removeItem */.cl)(key);
}

;// CONCATENATED MODULE: ../../../../browser-sdk/src/libraries/session-storage.js

function safeGetSessionStorage() {
    try {
        return window === null || window === void 0 ? void 0 : window.sessionStorage;
    } catch (_err) {
        // Catch a SecurityError that is thrown if the browser has disabled access
        // to session storage
        return undefined;
    }
}
function isAvailable() {
    return !!safeGetSessionStorage();
}
function getItem(key) {
    var storage = safeGetSessionStorage();
    if (!storage) {
        return undefined;
    }
    var string = storage.getItem(key);
    return JSON.parse(string);
}
function setItem(key, value) {
    var ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _broadcast = ref.broadcast, broadcast = _broadcast === void 0 ? false : _broadcast;
    var storage = safeGetSessionStorage();
    if (!storage) {
        return;
    }
    var stringToStore = JSON.stringify(value);
    storage.setItem(key, stringToStore);
    if (broadcast) {
        broadcastMessageToTabs("BROADCAST", {
            key: key,
            data: value
        });
    }
}
function removeItem(key) {
    var storage = safeGetSessionStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(key);
}


/***/ }),

/***/ 29518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getCurrencySymbol; },
/* harmony export */   "x": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
var intlCache = {};
function getCurrencySymbol(param) {
    var currency = param.currency, amount = param.amount, locale = param.locale;
    var ref;
    return (ref = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency
    }).formatToParts(amount).find(function(a) {
        return a.type === "currency";
    })) === null || ref === void 0 ? void 0 : ref.value;
}
function formatCurrency(param, locale) {
    var currency = param.currency, amount = param.amount, _hideDecimals = param.hideDecimals, hideDecimals = _hideDecimals === void 0 ? false : _hideDecimals;
    // Force consistent prefixed for $ and £. Without this en-GB gives 'US$' which is not what we want.
    var currencyLocale = (locale !== null && locale !== void 0 ? locale : currency === "USD") ? "en-US" : currency === "GBP" ? "en-GB" : locale !== null && locale !== void 0 ? locale : "en-US";
    var intlKey = "".concat(currencyLocale, "-").concat(currency);
    var formatter = intlCache[intlKey];
    if (!formatter) {
        var options = {
            style: "currency",
            currency: currency
        };
        if (hideDecimals) {
            options.minimumFractionDigits = 0;
            options.maximumFractionDigits = 0;
        }
        formatter = new Intl.NumberFormat(currencyLocale, options);
        intlCache[intlKey] = formatter;
    }
    return formatter.format(typeof amount === "number" ? amount : amount.toNumber());
}


/***/ }),

/***/ 2529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xG": function() { return /* reexport */ format_currency/* formatCurrency */.x; },
  "p6": function() { return /* reexport */ formatDate; },
  "_Q": function() { return /* reexport */ formatDateRange; },
  "uf": function() { return /* reexport */ formatNumber; },
  "jK": function() { return /* reexport */ format_currency/* getCurrencySymbol */.j; }
});

// UNUSED EXPORTS: formatPercentage

// EXTERNAL MODULE: ../../../../libraries/src/formatter/format-currency.ts
var format_currency = __webpack_require__(29518);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(81142);
;// CONCATENATED MODULE: ../../../../libraries/src/formatter/format-date.ts

var intlCache = {};
function formatDate(inputDate) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-GB", options = arguments.length > 2 ? arguments[2] : void 0;
    var formatterOptions = getDateTimeFormatOptionsForDate(inputDate, options);
    var formatter = getFormatter(locale, formatterOptions);
    return formatter.format(new Date(inputDate));
}
function formatDateRange(earliestDate, latestDate) {
    var locale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "en-GB", options = arguments.length > 3 ? arguments[3] : void 0;
    var formatterOptions = getDateTimeFormatOptionsForDateRange(earliestDate, latestDate, options);
    var formatter = getFormatter(locale, formatterOptions);
    return formatter.formatRange(new Date(earliestDate), new Date(latestDate));
}
function getFormatter(locale, options) {
    var key = [
        locale,
        Object.entries(options)
    ].toString();
    var formatter = intlCache[key];
    if (!formatter) {
        formatter = new Intl.DateTimeFormat(locale, options);
        intlCache[key] = formatter;
    }
    return formatter;
}
function getDateTimeFormatOptionsForDate(date, options) {
    var currentYear = new Date().getFullYear();
    var isSameYear = new Date(date).getFullYear() === currentYear;
    return (0,_object_spread/* default */.Z)({
        day: "numeric",
        month: "long",
        year: (options === null || options === void 0 ? void 0 : options.hideYearIfCurrent) && isSameYear ? undefined : "numeric"
    }, options);
}
function getDateTimeFormatOptionsForDateRange(earliestDate, latestDate, options) {
    var currentYear = new Date().getFullYear();
    var isSameYear = new Date(earliestDate).getFullYear() === currentYear && new Date(latestDate).getFullYear() === currentYear;
    return (0,_object_spread/* default */.Z)({
        day: "numeric",
        month: "short",
        year: (options === null || options === void 0 ? void 0 : options.hideYearIfCurrent) && isSameYear ? undefined : "numeric"
    }, options);
}

;// CONCATENATED MODULE: ../../../../libraries/src/formatter/format-number.ts
function formatNumber(number) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
    var formatter = new Intl.NumberFormat(locale);
    return formatter.format(number);
}

;// CONCATENATED MODULE: ../../../../libraries/src/formatter/index.ts






/***/ }),

/***/ 85391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81142);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62204);
/* harmony import */ var _purple_dot_browser_sdk_src_libraries_local_storage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93960);



function isInternalUser() {
    var internalUser = (0,_purple_dot_browser_sdk_src_libraries_local_storage__WEBPACK_IMPORTED_MODULE_0__/* .getItem */ .rV)("internal-user");
    if (!internalUser) {
        return false;
    }
    return internalUser.isInternalUser === true;
}
function isKnownBot() {
    var BOTS = /(pingdom)|(google)/i;
    return __webpack_require__.g.navigator.userAgent.match(BOTS);
}
var FilterWrapper = {
    track: function track(event, properties) {
        if (!(isInternalUser() || isKnownBot())) {
            var ref;
            (ref = window.FS) === null || ref === void 0 ? void 0 : ref.call(window, "trackEvent", {
                name: event,
                properties: properties
            });
        } else {
            // biome-ignore lint/suspicious/noConsole: debug
            console.log("INTERNAL USER - Track: ", event, properties);
        }
    }
};
var Analytics = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, FilterWrapper), {
    trackProductViewed: function trackProductViewed(param) {
        var itemId = param.itemId, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackProductViewed()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackProductViewed()");
        }
        FilterWrapper.track("Product Viewed", {
            itemId: itemId,
            slug: slug,
            product_id: slug
        });
    },
    trackOrderCreated: function trackOrderCreated(param) {
        var orderReference = param.orderReference;
        if (!orderReference) {
            throw new Error("No orderReference provided to Analytics.trackOrderCreated()");
        }
        FilterWrapper.track("Order Created", {
            orderReference: orderReference
        });
    },
    trackLastSeenProductClicked: function trackLastSeenProductClicked() {
        FilterWrapper.track("Last Seen Product Clicked");
    },
    trackInputChanged: function trackInputChanged(param) {
        var name = param.name;
        if (!name) {
            throw new Error("No name provided to Analytics.trackInputChanged");
        }
        FilterWrapper.track("".concat(name, " Changed"));
    },
    trackUserProgressed: function trackUserProgressed(pageName) {
        if (!pageName) {
            throw new Error("No page provided to Analytics.trackUserProgressed");
        }
        FilterWrapper.track("User Progressed", {
            pageName: pageName
        });
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (Analytics);


/***/ }),

/***/ 18531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81142);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62204);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60628);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38137);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60586);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90171);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62546);
/* harmony import */ var _common_ThemedButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57565);
/* harmony import */ var _common_media_queries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62540);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 75%;\n  padding: 18px;\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(_param) /*#__PURE__*/ {
    var className = _param.className, children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PositionedButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            "data-testid": "next-button"
        }, rest), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                children: children
            })
        }))
    });
})(_templateObject());
var PositionedButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_common_ThemedButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject1(), _common_media_queries__WEBPACK_IMPORTED_MODULE_4__/* .BelowMobile */ .fB);


/***/ }),

/***/ 92977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TextButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81142);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62204);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60628);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38137);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60586);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90171);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62546);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  background: none;\n  padding: 0px;\n  text-decoration: underline;\n  text-transform: uppercase;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var TextButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(_param) /*#__PURE__*/ {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        type: "button"
    }, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
            children: children
        })
    }));
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.body.color;
});


/***/ }),

/***/ 9365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$b": function() { return /* binding */ postCheckoutLoaded; },
/* harmony export */   "Bp": function() { return /* binding */ postGoToHomepage; },
/* harmony export */   "EI": function() { return /* binding */ postCloseCartClicked; },
/* harmony export */   "J5": function() { return /* binding */ postPreorderCheckoutStep; },
/* harmony export */   "PU": function() { return /* binding */ postClosedMessage; },
/* harmony export */   "lP": function() { return /* binding */ postCartCheckoutClicked; },
/* harmony export */   "py": function() { return /* binding */ postRemovedFromCart; },
/* harmony export */   "qr": function() { return /* binding */ postResizeMessage; },
/* harmony export */   "ux": function() { return /* binding */ trackCombinedPreorderCreated; },
/* harmony export */   "wH": function() { return /* binding */ postPreorderCheckoutSubmitted; },
/* harmony export */   "yu": function() { return /* binding */ postCartCleared; },
/* harmony export */   "zY": function() { return /* binding */ postPreorderFailed; }
/* harmony export */ });
/* unused harmony exports postPreorderCreated, postOrderCreated, trackOrderCreated, trackPreorderCreated, toTrackingOrderObject, toCombinedTrackingOrderObject, toTrackingCheckoutObject */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81142);
// Lifecycle

function postResizeMessage(data) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "PD_PLACEMENT_RESIZE"
    }, data));
}
function postCartCheckoutClicked(data) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "PD_CART_CHECKOUT_BUTTON_CLICKED"
    }, data));
}
function postCloseCartClicked(data) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "PD_CART_CLOSE_BUTTON_CLICKED"
    }, data));
}
// Checkout
function postCheckoutLoaded(data) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "CHECKOUT_LOADED"
    }, data));
}
function postPreorderCheckoutStep(checkoutViewModel, step) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "PREORDER_CHECKOUT_STEP"
    }, step, toTrackingCheckoutObject(checkoutViewModel)));
}
function postPreorderCheckoutSubmitted(data) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "PREORDER_CHECKOUT_SUBMITTED"
    }, data));
}
function postPreorderCreated(data) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "PREORDER_CREATED"
    }, data));
}
function postOrderCreated(data) {
    postMessage(_object_spread({
        type: "ORDER_CREATED"
    }, data));
}
function postPreorderFailed(data) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "PREORDER_FAILED"
    }, data));
}
function postClosedMessage(data) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "CLOSED"
    }, data));
}
function postRemovedFromCart(checkoutViewModel) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "REMOVED_FROM_CART"
    }, toTrackingCheckoutObject(checkoutViewModel)));
}
// Status
function postCartCleared() {
    postMessage({
        type: "CART_CLEARED"
    });
}
function trackOrderCreated(checkoutViewModel) {
    postOrderCreated(toTrackingOrderObject({
        checkoutViewModel: checkoutViewModel,
        type: "order"
    }));
}
function trackPreorderCreated(checkoutViewModel) {
    postPreorderCreated(toTrackingOrderObject({
        checkoutViewModel: checkoutViewModel,
        type: "preorder"
    }));
}
function trackCombinedPreorderCreated(checkoutViewModel) {
    postPreorderCreated(toCombinedTrackingOrderObject({
        checkoutViewModel: checkoutViewModel
    }));
}
function postGoToHomepage() {
    postMessage({
        type: "GO_TO_HOME_PAGE"
    });
}
/**
 * Used to build the tracking order object from checkoutViewModel
 * @param { Object } args
 * @param { Object } args.checkoutViewModel
 * @param { ('order'|'preorder') } args.type='preorder'
 * @returns Object
 */ function toTrackingOrderObject() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, checkoutViewModel = ref.checkoutViewModel, _type = ref.type, type = _type === void 0 ? "preorder" : _type;
    var ref1, ref2;
    var order = type === "preorder" ? checkoutViewModel.preorder : checkoutViewModel.order;
    var lineItems = type === "preorder" ? (ref1 = checkoutViewModel.preorder) === null || ref1 === void 0 ? void 0 : ref1.lineItems : (ref2 = checkoutViewModel.order) === null || ref2 === void 0 ? void 0 : ref2.lineItems;
    return {
        reference: order.reference,
        email: checkoutViewModel.email,
        shippingAddress: checkoutViewModel.shippingAddress,
        skuId: lineItems[0].sku.id,
        releaseId: lineItems[0].releaseId,
        lineItem: {
            sku: lineItems[0].sku.sku,
            properties: lineItems[0].lineItemProperties
        },
        lineItems: lineItems.map(function(lineItem) {
            return {
                id: lineItem.id,
                skuId: lineItem.sku.externalId,
                skuInternalId: lineItem.sku.id,
                productInternalId: lineItem.product.id,
                productId: lineItem.product.externalId,
                name: lineItem.sku.name,
                quantity: lineItem.quantity,
                price: {
                    amount: lineItem.price.amount,
                    currency: lineItem.price.currency
                },
                sku: lineItem.sku.sku,
                properties: lineItem.lineItemProperties
            };
        }),
        total: {
            amount: order.total.amount,
            currency: order.total.currency
        },
        tax: order.tax,
        shipping: order.shipping,
        discountCode: order.discountCode
    };
}
function toCombinedTrackingOrderObject() {
    var checkoutViewModel = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).checkoutViewModel;
    return {
        reference: checkoutViewModel.preorder.reference,
        email: checkoutViewModel.email,
        shippingAddress: checkoutViewModel.shippingAddress,
        lineItems: checkoutViewModel.combinedPreorderOrder.lineItems.map(function(lineItem) {
            return {
                id: lineItem.id,
                skuId: lineItem.sku.externalId,
                skuInternalId: lineItem.sku.id,
                productInternalId: lineItem.product.id,
                productId: lineItem.product.externalId,
                name: lineItem.sku.name,
                quantity: lineItem.quantity,
                price: {
                    amount: lineItem.price.amount,
                    currency: lineItem.price.currency
                },
                sku: lineItem.sku.sku,
                properties: lineItem.lineItemProperties,
                purchaseType: lineItem.purchaseType
            };
        }),
        total: checkoutViewModel.combinedPreorderOrder.total,
        tax: checkoutViewModel.combinedPreorderOrder.tax,
        shipping: checkoutViewModel.combinedPreorderOrder.shipping,
        discountCode: checkoutViewModel.combinedPreorderOrder.discountCode
    };
}
function toTrackingCheckoutObject(checkoutViewModel) {
    var ref, ref1;
    var lineItems = checkoutViewModel.lineItems;
    return {
        email: checkoutViewModel.email,
        shippingAddress: checkoutViewModel.shippingAddress,
        skuId: (ref = lineItems[0]) === null || ref === void 0 ? void 0 : ref.sku.id,
        releaseId: (ref1 = lineItems[0]) === null || ref1 === void 0 ? void 0 : ref1.releaseId,
        lineItem: lineItems[0] && {
            sku: lineItems[0].sku.sku,
            properties: lineItems[0].lineItemProperties
        },
        lineItems: lineItems.map(function(lineItem) {
            return {
                id: lineItem.id,
                skuId: lineItem.sku.externalId,
                skuInternalId: lineItem.sku.id,
                productInternalId: lineItem.product.id,
                productId: lineItem.product.externalId,
                name: lineItem.sku.name,
                quantity: lineItem.quantity,
                price: {
                    amount: lineItem.price.amount,
                    currency: lineItem.price.currency
                },
                sku: lineItem.sku.sku,
                properties: lineItem.lineItemProperties
            };
        }),
        total: {
            amount: checkoutViewModel.total.amount,
            currency: checkoutViewModel.total.currency
        },
        tax: checkoutViewModel.tax,
        shipping: checkoutViewModel.shipping,
        discountCode: checkoutViewModel.discountCode
    };
}
function postMessage(data) {
    window.parent.postMessage(data, "*");
}


/***/ }),

/***/ 57565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38137);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62546);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  transition: all 0.3s linear;\n\n  text-transform: uppercase;\n\n  background-color: ",
        ";\n  color: ",
        ";\n  letter-spacing: ",
        ";\n\n  &:disabled {\n    color: ",
        ";\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ThemedButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button */ .ZP.button(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.button.enabled.backgroundColor;
}, function(param) {
    var theme = param.theme;
    return theme.button.enabled.color;
}, function(param) {
    var theme = param.theme;
    return theme.button.enabled.letterSpacing;
}, function(param) {
    var theme = param.theme;
    return theme.button.disabled.color;
}, function(param) {
    var theme = param.theme;
    return theme.button.disabled.backgroundColor;
});
/* harmony default export */ __webpack_exports__["Z"] = (ThemedButton);


/***/ }),

/***/ 62540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fB": function() { return /* binding */ BelowMobile; }
/* harmony export */ });
/* unused harmony exports MOBILE_THRESHOLD, AboveLaptop, AboveMobile, BelowContainer, BelowContainerWithPadding */
var MOBILE_THRESHOLD = 750;
var AboveLaptop = "@media screen and (min-width: 1440px)";
var BelowMobile = "@media screen and (max-width: ".concat(750, "px)");
var AboveMobile = "@media screen and (min-width: ".concat(750, "px)");
var BelowContainer = "@media screen and (max-width: 1200px)";
var BelowContainerWithPadding = "@media screen and (max-width: 1320px)";


/***/ }),

/***/ 78115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useAsyncWithRequest; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81142);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60628);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22130);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90171);
/* harmony import */ var react_async__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82622);





function useAsyncWithRequest(args) {
    var wrappedRun = function wrappedRun() {
        for(var _len = arguments.length, runArgs = new Array(_len), _key = 0; _key < _len; _key++){
            runArgs[_key] = arguments[_key];
        }
        setRequest.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(runArgs));
        return run.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(runArgs));
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), request = ref[0], setRequest = ref[1];
    var _ref = (0,react_async__WEBPACK_IMPORTED_MODULE_2__/* .useAsync */ .r5)(args), run = _ref.run, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, [
        "run"
    ]);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        request: request,
        run: wrappedRun
    }, rest);
}


/***/ }),

/***/ 9743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36653);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81142);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62204);
/* harmony import */ var _juggle_resize_observer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69502);
/* harmony import */ var react_use_measure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50813);





/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
    var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _param);
    return (0,react_use_measure__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, options), {
        polyfill: _juggle_resize_observer__WEBPACK_IMPORTED_MODULE_0__/* .ResizeObserver */ ["do"]
    }));
};
;


/***/ }),

/***/ 62335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ cart; }
});

// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(79225);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(59573);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(38137);
// EXTERNAL MODULE: ../../../../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(60818);
// EXTERNAL MODULE: ../../../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(60586);
// EXTERNAL MODULE: ../../../../../node_modules/@juggle/resize-observer/lib/exports/resize-observer.js + 23 modules
var resize_observer = __webpack_require__(69502);
// EXTERNAL MODULE: ../../../../browser-sdk/src/libraries/session-storage.js + 1 modules
var session_storage = __webpack_require__(37175);
// EXTERNAL MODULE: ../../../../../node_modules/@use-it/event-listener/dist/event-listener.m.js
var event_listener_m = __webpack_require__(80039);
// EXTERNAL MODULE: ../../../../../node_modules/react/index.js
var react = __webpack_require__(90171);
// EXTERNAL MODULE: ../../../../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(62546);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_class_call_check.mjs
var src_class_call_check = __webpack_require__(5567);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_create_class.mjs
var src_create_class = __webpack_require__(31898);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(81142);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(62204);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(60628);
;// CONCATENATED MODULE: ../custom-server/scripts/src/client-checkout/checkout-backend/checkout-backend.js
/* eslint-disable max-classes-per-file */ /* eslint-disable class-methods-use-this */ /* eslint-disable no-underscore-dangle */ 






var checkout_backend_StoreCheckoutBackend = /*#__PURE__*/ function() {
    "use strict";
    function StoreCheckoutBackend(jsonApi, storeId, parentPage, locale) {
        (0,src_class_call_check/* default */.Z)(this, StoreCheckoutBackend);
        this.api = jsonApi;
        this.storeId = storeId;
        this.parentPage = parentPage;
        this.locale = locale;
        if (!this.api) {
            throw new Error("No jsonApi passed to StoreCheckoutBackend");
        }
        if (!this.storeId) {
            throw new Error("No storeId passed to StoreCheckoutBackend");
        }
    }
    (0,src_create_class/* default */.Z)(StoreCheckoutBackend, [
        {
            key: "fetch",
            value: function fetch(checkoutId) {
                var _this = this;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var response;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.api.get("/embedded-checkout/pre-order-checkouts/".concat(checkoutId))
                                ];
                            case 1:
                                response = _state.sent();
                                _this._throwOnError(response);
                                return [
                                    2,
                                    response.data
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "create",
            value: function create(param) {
                var userSession = param.userSession, lineItemRequest = param.lineItemRequest, discountCode = param.discountCode;
                var _this = this;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var parentPageSessionToken, _tmp, _ref, userSessionId, res, _tmp1, _tmp2, discountRes, _tmp3;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.parentPage;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.parentPage.getParentPageSessionToken()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                parentPageSessionToken = _tmp;
                                _tmp1 = {};
                                _tmp2 = {};
                                return [
                                    4,
                                    _this._callPostEndpoint("/embedded-checkout/pre-order-checkouts/create", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((_tmp1.storeId = _this.storeId, _tmp1.parentPageSessionToken = parentPageSessionToken, _tmp1.userSessionId = userSession.id(), _tmp1), lineItemRequest.toObj()), (_tmp2.salesChannel = getCheckoutSalesChannel(), _tmp2.locale = _this.locale, _tmp2)))
                                ];
                            case 3:
                                _ref = _state.sent(), userSessionId = _ref.userSessionId, res = (0,_object_without_properties/* default */.Z)(_ref, [
                                    "userSessionId"
                                ]);
                                userSession.set(userSessionId);
                                if (!discountCode) return [
                                    3,
                                    5
                                ];
                                _tmp3 = {};
                                return [
                                    4,
                                    _this._callPostEndpoint("/embedded-checkout/pre-order-checkouts/add-discount-code", (_tmp3.checkoutId = res.checkoutId, _tmp3.code = discountCode, _tmp3.autoApplied = true, _tmp3))
                                ];
                            case 4:
                                discountRes = _state.sent();
                                return [
                                    2,
                                    discountRes
                                ];
                            case 5:
                                return [
                                    2,
                                    res
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addLineItem",
            value: function addLineItem(checkoutId, lineItemRequest) {
                var _this = this;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var _tmp;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                return [
                                    4,
                                    _this._callPostEndpoint("/embedded-checkout/pre-order-checkouts/add", (0,_object_spread/* default */.Z)((_tmp.checkoutId = checkoutId, _tmp), lineItemRequest.toObj()))
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "replace",
            value: function replace(checkoutId, lineItemRequest) {
                var _this = this;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var _tmp;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                return [
                                    4,
                                    _this._callPostEndpoint("/embedded-checkout/pre-order-checkouts/replace", (0,_object_spread/* default */.Z)((_tmp.checkoutId = checkoutId, _tmp), lineItemRequest.toObj()))
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_callPostEndpoint",
            value: function _callPostEndpoint(url, body) {
                var _this = this;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var response;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.api.post(url, body)
                                ];
                            case 1:
                                response = _state.sent();
                                _this._throwOnError(response);
                                return [
                                    2,
                                    response.data
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_throwOnError",
            value: function _throwOnError(response) {
                var meta = response.meta, resError = response.error;
                // Stripe error is making it down to the frontend
                if (resError) {
                    var error = new Error(resError.message);
                    error.data = resError;
                    error.serverSide = true;
                    throw error;
                }
                if (meta.error) {
                    var error1 = new Error(meta.error);
                    error1.data = meta.errorData;
                    error1.serverSide = true;
                    throw error1;
                }
            }
        }
    ]);
    return StoreCheckoutBackend;
}();
function getCheckoutSalesChannel() {
    var searchParams = new URLSearchParams(window.location.search);
    return searchParams.get("salesChannel") || undefined;
}
/* harmony default export */ var checkout_backend = (checkout_backend_StoreCheckoutBackend);

;// CONCATENATED MODULE: ../../../../libraries/src/check-prop.ts
/* eslint-disable max-classes-per-file */ 
var C = function C() {
    "use strict";
    _class_call_check(this, C);
};
function check_prop_checkProp(obj, name) {
    if (obj[name] === undefined) {
        throw new Error("No ".concat(String(name), " passed to ").concat(obj.constructor.name, " constructor"));
    }
    return true;
}

// EXTERNAL MODULE: ../../../../../node_modules/ramda/es/all.js + 1 modules
var es_all = __webpack_require__(16985);
;// CONCATENATED MODULE: ../../../../libraries/src/interface/interface.ts


var Interface = /*#__PURE__*/ function() {
    "use strict";
    function Interface(spec) {
        (0,src_class_call_check/* default */.Z)(this, Interface);
        this.spec = spec;
        if (!this.spec || !this.spec.length) {
            throw new Error("Could not create Interface");
        }
    }
    var _proto = Interface.prototype;
    _proto.check = function check(obj) {
        var functionPresent = function functionPresent(key) {
            return obj[key] && typeof obj[key] === "function";
        };
        if (!obj) {
            return false;
        }
        return (0,es_all/* default */.Z)(functionPresent, this.spec);
    };
    return Interface;
}();

// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(35823);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_wrap_native_super.mjs + 2 modules
var _wrap_native_super = __webpack_require__(99076);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(2647);
;// CONCATENATED MODULE: ../custom-server/scripts/src/client-checkout/incognito-mode-error.js




var incognito_mode_error_IncognitoModeError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_inherits/* default */.Z)(IncognitoModeError, Error1);
    var _super = (0,_create_super/* default */.Z)(IncognitoModeError);
    function IncognitoModeError(cause) {
        (0,src_class_call_check/* default */.Z)(this, IncognitoModeError);
        var _this;
        _this = _super.call(this, "IncognitoModeError", {
            cause: cause
        });
        _this.name = "IncognitoModeError";
        return _this;
    }
    return IncognitoModeError;
}((0,_wrap_native_super/* default */.Z)(Error));
/* harmony default export */ var incognito_mode_error = (incognito_mode_error_IncognitoModeError);

;// CONCATENATED MODULE: ../custom-server/scripts/src/client-checkout/session-storage.js



/* eslint-disable class-methods-use-this */ var session_storage_SessionStorage = /*#__PURE__*/ function() {
    "use strict";
    function SessionStorage() {
        (0,src_class_call_check/* default */.Z)(this, SessionStorage);
    }
    (0,src_create_class/* default */.Z)(SessionStorage, [
        {
            key: "getItem",
            value: function getItem(key) {
                try {
                    return window.sessionStorage.getItem(key);
                } catch (err) {
                    throw new incognito_mode_error(err);
                }
            }
        },
        {
            key: "setItem",
            value: function setItem(key, value) {
                try {
                    window.sessionStorage.setItem(key, value);
                } catch (err) {
                    throw new incognito_mode_error(err);
                }
            }
        },
        {
            key: "removeItem",
            value: function removeItem(key) {
                try {
                    window.sessionStorage.removeItem(key);
                } catch (err) {
                    throw new incognito_mode_error(err);
                }
            }
        }
    ]);
    return SessionStorage;
}();
/* harmony default export */ var client_checkout_session_storage = (session_storage_SessionStorage);

;// CONCATENATED MODULE: ../custom-server/scripts/src/client-checkout/client-checkout.js
/* eslint-disable no-use-before-define */ /* eslint-disable max-classes-per-file */ /* eslint-disable no-underscore-dangle */ /* eslint-disable class-methods-use-this */ 









var listenerInterface = new Interface([
    "loading",
    "notLoading",
    "showError"
]);
/**
 * Can be run between multiple iframes
 */ var client_checkout_ClientCheckout = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function ClientCheckout(windowData, checkoutBackend, sdkCheckoutUpdates, errorHandler) {
        var _this = this;
        _class_call_check(this, ClientCheckout);
        this.windowData = windowData;
        this.checkoutBackend = checkoutBackend;
        this.sdkCheckoutUpdates = sdkCheckoutUpdates;
        this.errorHandler = errorHandler;
        checkProp(this, "windowData");
        checkProp(this, "checkoutBackend");
        checkProp(this, "sdkCheckoutUpdates");
        checkProp(this, "errorHandler");
        this.listeners = [];
        this.sessionStorage = new SessionStorage();
        this.userSession = new UserSession();
        this.persistedCheckout = new PersistedCheckout(checkoutBackend);
        this.request = AddRequest(checkoutBackend, windowData, this.userSession, this.persistedCheckout, sdkCheckoutUpdates);
        sdkCheckoutUpdates.onChangeShownToUser(function(d) {
            return _this._onCheckoutShown(d);
        });
    }
    _create_class(ClientCheckout, [
        {
            key: "frameLoaded",
            value: function frameLoaded() {
                try {
                    if (this.windowData.checkoutId) {
                        this.sessionStorage.setItem("serverCheckoutId", JSON.stringify(this.windowData.checkoutId));
                    } else {
                        this.sessionStorage.removeItem("serverCheckoutId");
                    }
                } catch (err) {
                    if (_instanceof(err, IncognitoModeError)) {
                        // Ignore incognito errors here, they will be thrown again and handled
                        // when the user takes an action
                        return;
                    }
                    throw err;
                }
            }
        },
        {
            key: "add",
            value: function add(lineItemRequest) {
                var _this = this;
                return _async_to_generator(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, listener, err;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = _this.listeners[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        listener = _step.value;
                                        listener.loading();
                                    }
                                } catch (err1) {
                                    _didIteratorError = true;
                                    _iteratorError = err1;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.request.execute(lineItemRequest)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                err = _state.sent();
                                if (_instanceof(err, IncognitoModeError)) {
                                    _this._handleIncognitoError();
                                    return [
                                        2
                                    ];
                                }
                                if (err.message.includes("is now sold out")) {
                                    _this._handleSoldOutError(err);
                                    return [
                                        2
                                    ];
                                }
                                if (err.message.includes("can only add")) {
                                    _this._handleQuantityLimitError(err);
                                    return [
                                        2
                                    ];
                                }
                                if (err.message.includes("already have all available units")) {
                                    _this._handleQuantityLimitError(err);
                                    return [
                                        2
                                    ];
                                }
                                if (err.message === "We're sorry there are currently too many people trying to check out. Please try again in 10 minutes.") {
                                    _this._handleShieldsUpError(err);
                                    return [
                                        2
                                    ];
                                }
                                if (err.message === "We're sorry there are currently too many people trying to check out. Please try again in 10 minutes.") {
                                    return [
                                        2
                                    ];
                                }
                                if (!err.message.match(/is now sold out|unable to find shipping rate/)) {
                                    _this.errorHandler.captureException(err);
                                }
                                // We log the error to the console for easier debugging
                                // in case any unexpected errors happen
                                // biome-ignore lint/suspicious/noConsole: log
                                console.error(err);
                                _this._handleUnrecognisedError();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "attachListener",
            value: function attachListener(listener) {
                var isListener = listenerInterface.check(listener);
                if (!isListener) {
                    throw new Error("Could not attach listener to checkoutSession");
                }
                this.listeners.push(listener);
            }
        },
        {
            key: "_handleIncognitoError",
            value: function _handleIncognitoError() {
                var errToSend = {
                    message: "Oops! Look like you're in incognito mode in your browser. Please turn off incognito to proceed with your order.",
                    isUserRetryable: false
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener.showError(errToSend);
                    }
                } catch (err1) {
                    _didIteratorError = true;
                    _iteratorError = err1;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_handleSoldOutError",
            value: function _handleSoldOutError(err) {
                var ref;
                var isUserRetryable = (ref = err.data) === null || ref === void 0 ? void 0 : ref.isUserRetryable;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener.showError({
                            message: err.message,
                            isUserRetryable: isUserRetryable
                        });
                    }
                } catch (err1) {
                    _didIteratorError = true;
                    _iteratorError = err1;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_handleQuantityLimitError",
            value: function _handleQuantityLimitError(err) {
                var ref;
                var isUserRetryable = (ref = err.data) === null || ref === void 0 ? void 0 : ref.isUserRetryable;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener.showError({
                            message: err.message,
                            isUserRetryable: isUserRetryable
                        });
                    }
                } catch (err1) {
                    _didIteratorError = true;
                    _iteratorError = err1;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_handleShieldsUpError",
            value: function _handleShieldsUpError(err) {
                var ref;
                var isUserRetryable = (ref = err.data) === null || ref === void 0 ? void 0 : ref.isUserRetryable;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener.showError({
                            message: err.message,
                            isUserRetryable: isUserRetryable
                        });
                    }
                } catch (err1) {
                    _didIteratorError = true;
                    _iteratorError = err1;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_handleUnrecognisedError",
            value: function _handleUnrecognisedError() {
                // We don't know what has gone wrong at this point
                // so we reset the cart and ask the user to refresh the page
                // so the backend can resync
                this.persistedCheckout.clear();
                var errToSend = {
                    message: "Oops! Small hiccup adding that to your cart. Please refresh the page and try again.",
                    isUserRetryable: true
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener.showError(errToSend);
                    }
                } catch (err1) {
                    _didIteratorError = true;
                    _iteratorError = err1;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_onCheckoutShown",
            value: function _onCheckoutShown() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener.notLoading();
                    }
                } catch (err1) {
                    _didIteratorError = true;
                    _iteratorError = err1;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ]);
    return ClientCheckout;
}()));
var PersistedCheckout = /*#__PURE__*/ function() {
    "use strict";
    function PersistedCheckout(checkoutBackend) {
        (0,src_class_call_check/* default */.Z)(this, PersistedCheckout);
        this.checkoutBackend = checkoutBackend;
        this.sessionStorage = new client_checkout_session_storage();
        check_prop_checkProp(this, "checkoutBackend");
    }
    (0,src_create_class/* default */.Z)(PersistedCheckout, [
        {
            key: "id",
            value: function id() {
                var _this = this;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._ensureCacheInSync()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this._locallyStoredId()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isPopulated",
            value: function isPopulated() {
                var _this = this;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var id;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.id()
                                ];
                            case 1:
                                id = _state.sent();
                                return [
                                    2,
                                    !!id
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "update",
            value: function update(data) {
                this.sessionStorage.setItem("checkoutSession", JSON.stringify(data));
                this.sessionStorage.setItem("serverCheckoutId", JSON.stringify(this._extractId(data)));
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.sessionStorage.removeItem("checkoutSession");
                this.sessionStorage.removeItem("serverCheckoutId");
            }
        },
        {
            key: "_ensureCacheInSync",
            value: function _ensureCacheInSync() {
                var _this = this;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var data, err;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this._serverCheckoutId()) return [
                                    3,
                                    1
                                ];
                                _this.sessionStorage.removeItem("checkoutSession");
                                return [
                                    3,
                                    5
                                ];
                            case 1:
                                if (!(_this._serverCheckoutId() !== _this._locallyStoredId())) return [
                                    3,
                                    5
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _this.checkoutBackend.fetch(_this._serverCheckoutId())
                                ];
                            case 3:
                                data = _state.sent();
                                if (data.state === "COMPLETED") {
                                    _this.clear();
                                } else {
                                    _this.update(data);
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                err = _state.sent();
                                if (err.serverSide) {
                                    _this.clear();
                                } else {
                                    throw err;
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_locallyStoredId",
            value: function _locallyStoredId() {
                var value = this.sessionStorage.getItem("checkoutSession");
                if (!value) {
                    return null;
                }
                return this._extractId(JSON.parse(value));
            }
        },
        {
            key: "_serverCheckoutId",
            value: function _serverCheckoutId() {
                var val = this.sessionStorage.getItem("serverCheckoutId");
                if (!val) {
                    return null;
                }
                return JSON.parse(val);
            }
        },
        {
            key: "_extractId",
            value: function _extractId(checkoutData) {
                var checkoutId = checkoutData.checkoutId, id = checkoutData.id;
                return checkoutId || id;
            }
        }
    ]);
    return PersistedCheckout;
}();
function AddRequest(checkoutApi, windowData, userSession, persistedCheckout, sdkCheckoutUpdates) {
    if (windowData.enableCartFlag) {
        return new SeparateCartAddRequest(checkoutApi, persistedCheckout, userSession, sdkCheckoutUpdates, windowData.discountCode);
    }
    return new ExpressCheckoutAddRequest(checkoutApi, persistedCheckout, userSession, sdkCheckoutUpdates, windowData.discountCode);
}
var SeparateCartAddRequest = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function SeparateCartAddRequest(checkoutBackend, persistedCheckout, userSession, sdkCheckoutUpdates, autoDiscount) {
        _class_call_check(this, SeparateCartAddRequest);
        this.checkoutBackend = checkoutBackend;
        this.persistedCheckout = persistedCheckout;
        this.sdkCheckoutUpdates = sdkCheckoutUpdates;
        this.userSession = userSession;
        this.autoDiscount = autoDiscount;
    }
    _create_class(SeparateCartAddRequest, [
        {
            key: "execute",
            value: function execute(lineItemRequest) {
                var _this = this;
                return _async_to_generator(function() {
                    var id, data, _tmp, lineItem, _tmp1;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.persistedCheckout.id()
                                ];
                            case 1:
                                id = _state.sent();
                                if (!id) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this._addLineItem(id, lineItemRequest)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                _tmp = {};
                                return [
                                    4,
                                    _this.checkoutBackend.create((_tmp.userSession = _this.userSession, _tmp.lineItemRequest = lineItemRequest, _tmp.discountCode = _this.autoDiscount, _tmp))
                                ];
                            case 4:
                                data = _state.sent();
                                _this.persistedCheckout.update(data);
                                lineItem = data.lineItems[data.lineItems.length - 1];
                                _tmp1 = {};
                                _this.sdkCheckoutUpdates.checkoutCreated((_tmp1.checkoutId = data.checkoutId, _tmp1.cartEnabled = true, _tmp1.lineItemRequest = lineItemRequest, _tmp1.lineItem = lineItem, _tmp1));
                                _state.label = 5;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_addLineItem",
            value: function _addLineItem(id, lineItemRequest) {
                var _this = this;
                return _async_to_generator(function() {
                    var data, lineItem, _tmp;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.checkoutBackend.addLineItem(id, lineItemRequest)
                                ];
                            case 1:
                                data = _state.sent();
                                _this.persistedCheckout.update(data);
                                lineItem = data.lineItems[data.lineItems.length - 1];
                                _tmp = {};
                                _this.sdkCheckoutUpdates.lineItemAdded((_tmp.checkoutId = data.checkoutId, _tmp.cartEnabled = true, _tmp.lineItemRequest = lineItemRequest, _tmp.lineItem = lineItem, _tmp));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return SeparateCartAddRequest;
}()));
var ExpressCheckoutAddRequest = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function ExpressCheckoutAddRequest(checkoutBackend, persistedCheckout, userSession, sdkCheckoutUpdates, autoDiscount) {
        _class_call_check(this, ExpressCheckoutAddRequest);
        this.checkoutBackend = checkoutBackend;
        this.persistedCheckout = persistedCheckout;
        this.userSession = userSession;
        this.sdkCheckoutUpdates = sdkCheckoutUpdates;
        this.autoDiscount = autoDiscount;
        if (!(this.checkoutBackend && this.persistedCheckout && this.userSession && this.sdkCheckoutUpdates)) {
            throw new Error("Could not create ExpressCheckoutAddRequest");
        }
    }
    _create_class(ExpressCheckoutAddRequest, [
        {
            key: "execute",
            value: function execute(lineItemRequest) {
                var _this = this;
                return _async_to_generator(function() {
                    var haveCheckoutLocally, data, id, _tmp, lineItem, _tmp1;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.persistedCheckout.isPopulated()
                                ];
                            case 1:
                                haveCheckoutLocally = _state.sent();
                                if (!haveCheckoutLocally) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.persistedCheckout.id()
                                ];
                            case 2:
                                id = _state.sent();
                                return [
                                    4,
                                    _this.checkoutBackend.replace(id, lineItemRequest)
                                ];
                            case 3:
                                data = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                _tmp = {};
                                return [
                                    4,
                                    _this.checkoutBackend.create((_tmp.userSession = _this.userSession, _tmp.lineItemRequest = lineItemRequest, _tmp.discountCode = _this.autoDiscount, _tmp))
                                ];
                            case 5:
                                data = _state.sent();
                                _state.label = 6;
                            case 6:
                                _this.persistedCheckout.update(data);
                                lineItem = data.lineItems[data.lineItems.length - 1];
                                _tmp1 = {};
                                _this.sdkCheckoutUpdates.checkoutCreated((_tmp1.checkoutId = data.checkoutId, _tmp1.cartEnabled = false, _tmp1.lineItemRequest = lineItemRequest, _tmp1.lineItem = lineItem, _tmp1));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ExpressCheckoutAddRequest;
}()));
/* harmony default export */ var client_checkout = ((/* unused pure expression or super */ null && (client_checkout_ClientCheckout)));


;// CONCATENATED MODULE: ../custom-server/scripts/src/client-checkout/json-api/json-api.js
/* eslint-disable class-methods-use-this */ 



var json_api_JsonApi = /*#__PURE__*/ function() {
    "use strict";
    function JsonApi() {
        (0,src_class_call_check/* default */.Z)(this, JsonApi);
    }
    (0,src_create_class/* default */.Z)(JsonApi, [
        {
            key: "get",
            value: function get(url, body) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var res, _tmp, response;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                return [
                                    4,
                                    fetch(url, (_tmp.body = JSON.stringify(body), _tmp.headers = new Headers({
                                        Accept: "application/json",
                                        "Content-Type": "application/json"
                                    }), _tmp))
                                ];
                            case 1:
                                res = _state.sent();
                                return [
                                    4,
                                    res.json()
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "post",
            value: function post(url, body) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var res, _tmp, response;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                return [
                                    4,
                                    fetch(url, (_tmp.method = "POST", _tmp.body = JSON.stringify(body), _tmp.headers = new Headers({
                                        Accept: "application/json",
                                        "Content-Type": "application/json"
                                    }), _tmp))
                                ];
                            case 1:
                                res = _state.sent();
                                return [
                                    4,
                                    res.json()
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return JsonApi;
}();
/* harmony default export */ var json_api = (json_api_JsonApi);

;// CONCATENATED MODULE: ../custom-server/scripts/src/client-checkout/index.js


/* eslint-disable no-underscore-dangle */ 


function ReadyMadeClientCheckout(param) {
    var parentPage = param.parentPage, sentry = param.sentry;
    var clientCheckout = new ClientCheckout(window.__DATA__, new StoreCheckoutBackend(new JsonApi(), window.__DATA__.storeId, parentPage, window.__DATA__.locale), new IframeSDKCheckoutUpdates(parentPage), sentry);
    return clientCheckout;
}
function ReadyMadePersistedCheckout(windowData) {
    return new PersistedCheckout(new checkout_backend(new json_api(), windowData.storeId));
}
/* harmony default export */ var src_client_checkout = ((/* unused pure expression or super */ null && (ReadyMadeClientCheckout)));


// EXTERNAL MODULE: ./components/EmbeddedApp/PageTypes/IframePage/AnalyticsProvider.jsx
var AnalyticsProvider = __webpack_require__(88853);
// EXTERNAL MODULE: ./components/EmbeddedApp/checkout-api.js
var checkout_api = __webpack_require__(77799);
// EXTERNAL MODULE: ./components/common/config-context.tsx
var config_context = __webpack_require__(43985);
// EXTERNAL MODULE: ./components/common/use-async-with-request.jsx
var use_async_with_request = __webpack_require__(78115);
// EXTERNAL MODULE: ./components/common/use-measure.js
var use_measure = __webpack_require__(9743);
// EXTERNAL MODULE: ./components/use-translation.ts + 7 modules
var use_translation = __webpack_require__(84687);
// EXTERNAL MODULE: ../../../../libraries/src/formatter/index.ts + 2 modules
var formatter = __webpack_require__(2529);
// EXTERNAL MODULE: ./components/common/media-queries.js
var media_queries = __webpack_require__(62540);
// EXTERNAL MODULE: ./components/EmbeddedApp/components/TextButton.tsx
var TextButton = __webpack_require__(92977);
;// CONCATENATED MODULE: ./components/EmbeddedApp/EmbeddedCart/Item.jsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  padding: 18px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100px;\n  height: auto;\n  margin-right: 18px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  color: ",
        ";\n\n  ",
        " {\n    letter-spacing: 1px;\n    text-align: left;\n    font-size: 16px;\n    width: 100%;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  a {\n    color: ",
        ";\n  }\n  a:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n\n  margin-top: 23px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  text-transform: uppercase;\n\n  font-size: 14px;\n  letter-spacing: 1px;\n  color: ",
        ";\n\n  &:last-child {\n    margin-bottom: 0px;\n  }\n\n  &:after {\n    content: '/';\n    margin-left: 4px;\n    margin-right: 4px;\n  }\n\n  &:last-child:after {\n    content: '';\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}








function Item(param) {
    var lineItem = param.lineItem, RemoveLineItemTask = param.RemoveLineItemTask;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z)();
    var i18n = (0,use_translation/* useTranslation */.$)().i18n;
    var sku = lineItem.sku;
    var isRemoving = RemoveLineItemTask.isPending && RemoveLineItemTask.request.lineItemId === lineItem.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemContainer, {
        "data-testid": "cart-item",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                src: sku.imageURL,
                alt: sku.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemDetailsContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                        "data-testid": "product-name",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: sku.url,
                            target: "_parent",
                            children: sku.name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantRowContainer, {
                        "data-testid": "variant-options",
                        children: sku.displayOptions.map(function(param) {
                            var label = param.label, value = param.value;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantOption, {
                                children: value
                            }, "".concat(label, "-").concat(value));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                                "data-testid": "product-price",
                                children: (0,formatter/* formatCurrency */.xG)(sku.price, i18n.resolvedLanguage)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextButton/* TextButton */.A, {
                                "data-testid": "remove-item",
                                disabled: isRemoving,
                                onClick: function onClick() {
                                    analytics.track("Product Removed");
                                    RemoveLineItemTask.run({
                                        lineItemId: lineItem.id
                                    });
                                },
                                children: isRemoving ? "Removing..." : "Remove"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var ItemContainer = styled_components_browser_esm/* default.li */.ZP.li(_templateObject());
var Image = styled_components_browser_esm/* default.img */.ZP.img(_templateObject1());
var LabelText = styled_components_browser_esm/* default.span */.ZP.span(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.header.color;
}, media_queries/* BelowMobile */.fB);
var Name = (0,styled_components_browser_esm/* default */.ZP)(LabelText)(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.text.header.color;
}, function(param) {
    var theme = param.theme;
    return theme.text.header.color;
});
var Price = (0,styled_components_browser_esm/* default */.ZP)(LabelText)(_templateObject4());
var PriceRow = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5());
var ItemDetailsContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6());
var VariantRowContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject7());
var VariantOption = styled_components_browser_esm/* default.div */.ZP.div(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.text.body.color;
});
/* harmony default export */ var EmbeddedCart_Item = (Item);

// EXTERNAL MODULE: ./components/EmbeddedApp/components/Button.tsx
var Button = __webpack_require__(18531);
;// CONCATENATED MODULE: ./components/EmbeddedApp/EmbeddedCart/OpenCheckoutButton.tsx


function OpenCheckoutButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    OpenCheckoutButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function OpenCheckoutButton(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, (0,_object_spread/* default */.Z)({
        "data-testid": "open-checkout"
    }, props));
}
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z)(OpenCheckoutButton_templateObject());

// EXTERNAL MODULE: ./components/EmbeddedApp/PageTypes/IframePage/EmbeddedPage.jsx + 1 modules
var EmbeddedPage = __webpack_require__(19740);
// EXTERNAL MODULE: ./components/EmbeddedApp/parent-page.js
var parent_page = __webpack_require__(9365);
// EXTERNAL MODULE: ./components/common/fullstory.tsx
var fullstory = __webpack_require__(39144);
// EXTERNAL MODULE: ./webserver-page.tsx
var webserver_page = __webpack_require__(15334);
;// CONCATENATED MODULE: ./pages/embedded-checkout/cart.jsx




function cart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    cart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function cart_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    cart_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function cart_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: bold;\n  color: ",
        ";\n  text-transform: uppercase;\n  border: none;\n  background: none;\n  text-decoration: underline;\n"
    ]);
    cart_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function cart_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: white;\n  width: 100%;\n  height: 100%;\n  padding-bottom: 23px;\n\n  font-family: ",
        ";\n  color: ",
        ";\n  background-color: ",
        ";\n"
    ]);
    cart_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function cart_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 16px;\n  padding-top: 32px;\n"
    ]);
    cart_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function cart_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  margin-bottom: 0px;\n\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: 600;\n  color: ",
        ";\n\n  ",
        " {\n    font-size: 20px;\n  }\n"
    ]);
    cart_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function cart_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-weight: 300;\n  color: ",
        ";\n  letter-spacing: auto;\n\n  ",
        " {\n    font-size: 16px;\n    font-weight: 400 !important;\n  }\n"
    ]);
    cart_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function cart_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  margin: 0px;\n  padding: 0px;\n  max-height: 66vw;\n  overflow: auto;\n\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    cart_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function cart_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 18px;\n"
    ]);
    cart_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n\n  padding: 0px 18px;\n  padding-top: 18px;\n\n  & > p {\n    font-weight: normal;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n    color: ",
        ";\n    margin-bottom: 8px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: rgb(227, 44, 43);\n  margin: 18px;\n  margin-top: 0;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}




















function Cart(param) {
    var view = param.view;
    var persistedCheckoutRef = (0,react.useRef)(ReadyMadePersistedCheckout(view));
    var persistedCheckout = persistedCheckoutRef.current;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z)();
    var ref = (0,react.useState)(null), checkout = ref[0], setCheckout = ref[1];
    var ref1 = useParentPageResizeEffect();
    var ref2 = (0,react.useState)(null), error = ref2[0], setError = ref2[1];
    var t = (0,use_translation/* useTranslation */.$)().t;
    (0,event_listener_m/* default */.Z)("message", function(event) {
        var ref;
        if ((ref = event.data) === null || ref === void 0 ? void 0 : ref.type) {
            if (event.data.type === "CART_SHOWN") {
                analytics.track("Cart Viewed");
            }
            if (event.data.type === "CART_HIDDEN") {
                analytics.track("Cart Dismissed");
            }
        }
    });
    (0,react.useEffect)(function() {
        var elem = document.body;
        var resizeObserver = new resize_observer/* ResizeObserver */["do"](function() {
            window.parent.postMessage({
                meta: {
                    placementType: "cart",
                    type: "window-size-changed"
                },
                data: {
                    width: elem.offsetWidth,
                    height: elem.offsetHeight
                }
            }, "*");
        });
        resizeObserver.observe(elem);
        setInterval(function() {
            var checkoutSession = session_storage/* getItem */.rV("checkoutSession");
            setCheckout(checkoutSession);
            var fullstoryElem = document.querySelector("#fullstory-snippet");
            if (checkoutSession && !fullstoryElem) {
                var script = document.createElement("script");
                script.id = "fullstory-snippet";
                script.innerHTML = fullstory/* FullStorySnippetString */.J;
                document.body.appendChild(script);
            }
        }, 500);
    }, []);
    var RemoveLineItemTask = (0,use_async_with_request/* useAsyncWithRequest */.K)({
        deferFn: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
                var _param, lineItemId, checkoutId, _tmp;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _param = (0,_sliced_to_array/* default */.Z)(param, 1), lineItemId = _param[0].lineItemId;
                            return [
                                4,
                                persistedCheckout.id()
                            ];
                        case 1:
                            checkoutId = _state.sent();
                            _tmp = {};
                            return [
                                2,
                                checkout_api/* removeItemFromCheckout */.pw([
                                    (_tmp.checkoutId = checkoutId, _tmp.lineItemId = lineItemId, _tmp)
                                ])
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        onResolve: function onResolve(data) {
            if (data.lineItems.length === 0) {
                persistedCheckout.clear();
                parent_page/* postCartCleared */.yu();
            } else {
                persistedCheckout.update(data);
                setCheckout(data);
            }
            parent_page/* postRemovedFromCart */.py(data);
        },
        onReject: function onReject(err) {
            setError(err.originalMessage);
        }
    });
    var apiKey = view.apiKey;
    // Temp workaround: if checkout.state === COMPLETED, the shape of the
    // resulting object is different, so just return nothing instead of crashing :(
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmbeddedPage/* default */.Z, {
        head: view,
        useFullstory: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCSS, {
                globalCSS: view.globalCSS
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm/* ThemeProvider */.f6, {
                theme: view.theme,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartContainer, {
                    ref: ref1,
                    children: checkout && checkout.state !== "COMPLETED" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSection, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        children: checkout.isAddingToPreorder ? t("translation:checkout.add-to-pre-order") : t("translation:self-service.pre-order:your-pre-order")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                                        "data-testid": "dispatch-dates",
                                        children: checkout.dispatching.datesDisplay
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineItemsContainer, {
                                children: [
                                    checkout.lineItems.map(function(lineItem) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedCart_Item, {
                                            lineItem: lineItem,
                                            RemoveLineItemTask: RemoveLineItemTask,
                                            canRemove: checkout.lineItems.length > 1
                                        }, lineItem.id);
                                    }),
                                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartError, {
                                        error: error
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TotalContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: t("translation:checkout.subtotal")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: checkout.subtotal.display
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonPosition, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenCheckoutButton, {
                                    onClick: function onClick() {
                                        analytics.track("Cart Viewed");
                                        onCheckoutClicked({
                                            apiKey: apiKey
                                        });
                                    },
                                    children: t("translation:checkout.checkout")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButtonPosition, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_TextButton, {
                                    onClick: function onClick() {
                                        analytics.track("Cart Dismissed");
                                        parent_page/* postCloseCartClicked */.EI();
                                    },
                                    children: t("translation:checkout.close")
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function useParentPageResizeEffect() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_measure/* default */.Z)(), 2), ref1 = ref[0], bounds = ref[1];
    (0,react.useEffect)(function() {
        postResizeMessage({
            width: bounds.width,
            height: bounds.height
        });
    }, [
        bounds.width,
        bounds.height
    ]);
    return ref1;
}
function onCheckoutClicked(param) {
    var apiKey = param.apiKey;
    var checkoutSession = session_storage/* getItem */.rV("checkoutSession");
    if (checkoutSession) {
        parent_page/* postCartCheckoutClicked */.lP({
            apiKey: apiKey,
            checkoutId: checkoutSession.id
        });
    }
}
function postResizeMessage(param) {
    var width = param.width, height = param.height;
    parent_page/* postResizeMessage */.qr({
        id: "purple-dot-cart",
        width: width,
        height: height
    });
}
var GlobalCSS = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(cart_templateObject(), function(param) {
    var globalCSS = param.globalCSS;
    return globalCSS || "";
});
var CloseButtonPosition = styled_components_browser_esm/* default.div */.ZP.div(cart_templateObject1());
var cart_TextButton = styled_components_browser_esm/* default.button */.ZP.button(cart_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.header.color;
});
var CartContainer = styled_components_browser_esm/* default.div */.ZP.div(cart_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.text.body.fontFamily;
}, function(param) {
    var theme = param.theme;
    return theme.text.body.color;
}, function(param) {
    var theme = param.theme;
    return theme.modal.backgroundColor;
});
var HeaderSection = styled_components_browser_esm/* default.div */.ZP.div(cart_templateObject4());
var Title = styled_components_browser_esm/* default.h1 */.ZP.h1(cart_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.title.fontSize;
}, function(param) {
    var theme = param.theme;
    return theme.title.fontSize;
}, function(param) {
    var theme = param.theme;
    return theme.text.header.color;
}, media_queries/* BelowMobile */.fB);
var Subtitle = styled_components_browser_esm/* default.h2 */.ZP.h2(cart_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.text.body.fontFamily;
}, function(param) {
    var theme = param.theme;
    return theme.text.body.color;
}, media_queries/* BelowMobile */.fB);
var LineItemsContainer = styled_components_browser_esm/* default.ul */.ZP.ul(cart_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.borderColor;
});
var ButtonPosition = styled_components_browser_esm/* default.div */.ZP.div(cart_templateObject8());
var TotalContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.text.header.color;
});
var CartError = (0,styled_components_browser_esm/* default */.ZP)(function(param) {
    var className = param.className, error = param.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        "data-testid": "cart-error",
        children: error
    });
})(_templateObject10());
/* harmony default export */ var cart = ((0,webserver_page/* default */.Z)(Cart));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8782,6672,2622,9502,4391,5789,9740,7799,9774,2888,179], function() { return __webpack_exec__(68387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);